/**
 * Where a customer opened the personalization page from, for preview telemetry.
 * DOM-free so it can be unit-tested with `node --test`; same UMD shim as
 * assets/template-name-resolver.js.
 *
 * Why this exists: previews reached the generator with template_name null because the page
 * was opened from a link without ?template_name_girl= / ?template_name_boy=, and nothing
 * recorded which link. Only the params that decide the template are kept, plus the names of
 * the others, so no personal data reaches the logs.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.PreviewPageContext = api;
})(typeof self !== 'undefined' ? self : this, function () {
  var KEPT = ['product_handle', 'template_name_girl', 'template_name_boy', 'template_name', 'preview_id', 'client-id'];

  function pageContext(search, referrer) {
    var params = new URLSearchParams(search || '');
    var pageParams = {};
    var keys = [];
    params.forEach(function (value, key) {
      keys.push(key);
      if (KEPT.indexOf(key) !== -1) pageParams[key] = value;
    });

    var ref = null;
    try {
      var url = new URL(referrer);
      ref = url.origin + url.pathname;
    } catch (e) {
      ref = null;
    }

    return { page_params: pageParams, page_param_keys: keys, referrer: ref };
  }

  return { pageContext: pageContext };
});
